<template>
  <transition name="slide-up">
    <div v-if="showBanner" class="cookie-consent-banner">
      <div class="cookie-consent-container">
        <div class="cookie-content">
          <div class="cookie-text">
            <h3>We value your privacy</h3>
            <p>
              We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. 
              By clicking "Accept All", you consent to our use of cookies.
              <a href="https://scienlabs.com/privacy-policy/" target="_blank">Privacy Policy</a>
            </p>
          </div>
          <div class="cookie-actions">
            <button 
              class="btn-cookie btn-cookie-preferences"
              @click="openPreferences"
            >
              Customize
            </button>
            <button 
              class="btn-cookie btn-cookie-reject"
              @click="rejectAll"
            >
              Reject All
            </button>
            <button 
              class="btn-cookie btn-cookie-accept"
              @click="acceptAll"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CookieConsentBanner',
  computed: {
    ...mapState({
      showBanner: state => state.cookieConsent.showBanner
    })
  },
  methods: {
    ...mapActions([
      'acceptAllCookies',
      'rejectAllCookies',
      'openCookiePreferences'
    ]),
    acceptAll() {
      this.acceptAllCookies()
    },
    rejectAll() {
      this.rejectAllCookies()
    },
    openPreferences() {
      this.openCookiePreferences()
    }
  }
}
</script>

<style scoped>
.cookie-consent-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  padding: 20px;
  border-top: 1px solid #e0e0e0;
}

.cookie-consent-container {
  max-width: 1200px;
  margin: 0 auto;
}

.cookie-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}

.cookie-text {
  flex: 1;
  min-width: 300px;
}

.cookie-text h3 {
  margin: 0 0 10px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.cookie-text p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.cookie-text a {
  color: #007bff;
  text-decoration: underline;
  margin-left: 5px;
}

.cookie-text a:hover {
  color: #0056b3;
}

.cookie-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.btn-cookie {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn-cookie-accept {
  background: #28a745;
  color: white;
}

.btn-cookie-accept:hover {
  background: #218838;
}

.btn-cookie-reject {
  background: #f8f9fa;
  color: #333;
  border: 1px solid #dee2e6;
}

.btn-cookie-reject:hover {
  background: #e2e6ea;
}

.btn-cookie-preferences {
  background: #6c757d;
  color: white;
}

.btn-cookie-preferences:hover {
  background: #5a6268;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
}

@media (max-width: 768px) {
  .cookie-content {
    flex-direction: column;
    text-align: center;
  }
  
  .cookie-actions {
    width: 100%;
    justify-content: center;
  }
  
  .btn-cookie {
    flex: 1;
    min-width: 100px;
  }
}
</style>